import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DESCRIPCION_STATUS_CANJE } from 'src/app/shared/constantes/constants';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Supervisor } from 'src/app/models/supervisor.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { RedimirSupervisor } from 'src/app/models/redimir.interface';
import { CasoClinico, CasoClinicoFormatoXLS } from 'src/app/models/caso-clinico.interface';
import { Puntos } from 'src/app/models/catalogos.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-administrador-supervisor',
  templateUrl: './administrador-supervisor.component.html',
  styleUrls: ['./administrador-supervisor.component.scss']
})
export class AdministradorSupervisorComponent {
  showModal = false;
  idSupervisor: string = '0';
  supervisor!: Supervisor;
  productividadSupervisorForm!: FormGroup;
  currentPageCasosClinicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;
  statusCanje: string[] = [...DESCRIPCION_STATUS_CANJE];
 accionPendiente: 'cancelar' | 'rechazar' | null = null;
  casoclinicopuntos!: CasoClinico;
  currentPageCanjes: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCanjes: number = 0;

  puntosForm!: FormGroup;
  catalogoPuntos: Puntos[] = [];

  get casosClinicos(): CasoClinico[] {
    const startIndex = (this.currentPageCasosClinicos.page) * this.currentPageCasosClinicos.rows;
    return this.supervisor.casosclinicos.slice(startIndex, startIndex + this.currentPageCasosClinicos.rows);
  }
  get totalPaginasCasosClinicos(): number {
    return Math.ceil(this.supervisor.casosclinicos.length / this.currentPageCasosClinicos.rows);
  }
  get canjes(): RedimirSupervisor[] {
    const startIndex = (this.currentPageCanjes.page) * this.currentPageCanjes.rows;
    return this.supervisor.canjes.slice(startIndex, startIndex + this.currentPageCanjes.rows);
  }
  get totalPaginasCanjes(): number {
    return Math.ceil(this.supervisor.canjes.length / this.currentPageCanjes.rows);
  }
  get canjesPagados(): number {
    return this.supervisor.canjes.filter((item) => item.status == 3).reduce((acumulador: number, item: RedimirSupervisor) => acumulador + item.redimir, 0);
  }
  constructor(
    private activedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private messageService: MessageService,
    private administradorService: AdministradorService) {
    this.idSupervisor = this.activedRoute.snapshot.params['id'];
    this.getSupervisor(this.idSupervisor);
    this.puntosForm = this.crearFormulario();
    this.productividadSupervisorForm = this.crearFormularioProductividad();
  }
   crearFormulario(): FormGroup {
    return this.fb.group({
      puntos: [null, Validators.required],
      id: [null]
    })
  }
  crearFormularioProductividad(): FormGroup {
    return this.fb.group({
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required]
    })
  }
  getSupervisor(id: string): void {
    this.administradorService.getSupervisor(id)
      .subscribe({
        next: (resp) => {
          this.supervisor = resp.datos;
          this.totalItemsCasosClinicos = this.supervisor.casosclinicos.length;
          this.showSuccess(resp.mensaje);
          console.log(resp)
        },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err) }
      })
  }
  onPageChangeCasosClinicos(event: any) {
    this.currentPageCasosClinicos = <Paginar>event;
  }
  onPageChangeCanjes(event: any) {
    this.currentPageCanjes = <Paginar>event;
  }
  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }
  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }
  formatDateISO(date: Date) {
    // Convert the date to ISO string
    const isoString = date.toISOString();
    // Split at the "T" character to get the date part
    const formattedDate = isoString.split("T")[0];
    return formattedDate;
  }
  getCanje(id: number): string {
    return this.statusCanje[id];
  }
  onSubmit(): void {
    const puntos: Puntos = this.puntosForm.get('puntos')?.value;
    const id = this.puntosForm.get('id')?.value;

    this.administradorService.asignarPuntosCasoClinicoSupervisor(this.casoclinicopuntos.id, puntos.puntos)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.casoclinicopuntos.s_puntos = puntos.puntos;
          this.closeModal();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
        }

      })

  }
   closeModal(): void {
    this.showModal = false;
    this.accionPendiente = null;
  }

  openModal(): void {
    this.accionPendiente = 'rechazar';
    this.showModal = true;
  }
  cancelarAccion(): void {
    this.resetForm();
    this.catalogoPuntos = [];
    this.closeModal();
  }
  asignarpuntos(casoclinico: CasoClinico): void {
    this.resetForm();
    this.administradorService.catalogoPuntos()
      .subscribe({
        next: (resp) => {
          this.catalogoPuntos = resp;
          this.casoclinicopuntos = casoclinico;
          this.openModal();
        },
        error: (err) => {
          console.log(err);
        }
      });

  }
  resetForm(): void {
    this.puntosForm.reset();
  }
  exportPDF(): void {
    const fechas = this.productividadSupervisorForm.value;
    const fechaInicio = this.formatDateISO(fechas.fechaInicio);
    const fechaFin = this.formatDateISO(fechas.fechaFin);
    const url = environment.urlbase + environment.pdfs.productividadSupervisor + this.idSupervisor + `/${fechaInicio}/${fechaFin}`;
    window.open(url, '_blank');


    window.location.href = url;
  }
  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const casosClinicos: CasoClinicoFormatoXLS[] = this.fullCasosClinicosXLSX(this.supervisor.casosclinicos);
    const nombreEnfermera = [{ campo: "Supervisor", nomSupervisor: this.supervisor.nom_supervisor }];
    const fileName = 'supervisor-casosclinicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, nombreEnfermera, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, casosClinicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'casos_clinicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  fullCasosClinicosXLSX(casoclinico: CasoClinico[]): CasoClinicoFormatoXLS[] {
    const casosclinicosxlsx: CasoClinicoFormatoXLS[] = casoclinico.map((item) => {
      return <CasoClinicoFormatoXLS>{
        fecha: item.fecha,
        folio: item.folio,
        serie: item.serie,
        paciente: item.paciente,
        sexo: item.sexo,
        edad: item.edad,
        antecedente: item.antecedente,
        institucion: item.cveInstitucion,
        hospital: item.nomHospital,
        fechaAplicacionProducto: item.fechaAplicacionProducto,
        diagnostico: item.diagnostico,
        antibiotico1: item.nomAntibiotico1,
        cantidad1: item.cantidad1,
        antibiotico2: item.nomAntibiotico2,
        cantidad2: item.cantidad2,
        antibiotico3: item.nomAntibiotico3,
        cantidad3: item.cantidad3,
        tratamiento: item.tratamiento,
        cuerpo: item.nomCuerpo,
        observacion: item.observacion,
        medico: item.medico.nom_medico,
        productos: item.productos.length,
        documentos: item.documentos.length
      }
    });
    return casosclinicosxlsx;
  }
  regresar(): void {
    this.router.navigate(['/administrador/supervisores'])
  }
}
/*
 exportExcelv0(): void {
   const casosClinicos: CasoClinico[] = this.enfermera.casosclinicos;

   import('xlsx').then((xlsx) => {
     const worksheet = xlsx.utils.json_to_sheet(casosClinicos);
     const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
     const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
     this.saveAsExcelFile(excelBuffer, 'products');
   });
 }

 saveAsExcelFile(buffer: any, fileName: string): void {
   
   let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
   let EXCEL_EXTENSION = '.xlsx';
   const data: Blob = new Blob([buffer], {
       type: EXCEL_TYPE
   });
   FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
   
 }
 */